import React from 'react'
import { Button } from '@mui/material'
import styled, { keyframes } from 'styled-components'
import LoopIcon from '@mui/icons-material/Loop'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'

const rotatingIcon = keyframes`
  0% { transform: rotate(360deg); }
  100% { transform: rotate(0deg); }
`

const colorChangeIcon = keyframes`
  0%, 50% { color: #66d432; }
  100% { color: #344767; }
`

const ChangesSavedIcon = styled(CheckCircleOutlineIcon)`
  &.saved {
    color: #344767;
    font-size: 1.5rem !important;
    animation: 2s ${colorChangeIcon} ease-out;
  }
`

const SavingIcon = styled(LoopIcon)`
  &.loading {
    color: #344767;
    font-size: 1.5rem !important;
    animation: 1.5s ${rotatingIcon} linear infinite;
  }
`

const LoadingButton = ({ loading, onClick, sx }) => {
  return (
    <Button
      variant="gradient"
      color="dark"
      sx={{ height: '100%', ...sx }}
      onClick={onClick}
      startIcon={
        loading ? (
          <SavingIcon fontSize="medium" className="loading" />
        ) : (
          <ChangesSavedIcon fontSize="medium" className="saved" />
        )
      }
    >
      {loading ? 'updating...' : 'up to date'}
    </Button>
  )
}

export default LoadingButton
